'use client';
import { useState } from 'react';

const TwitterIcon = () => {
  const [iconColor, setIconColor] = useState('url(#paint0_linear_0_254)'); // Изначальный цвет с градиентом

  const handleMouseEnter = () => {
    setIconColor('#FFFFFF'); // Цвет белый при наведении
  };

  const handleMouseLeave = () => {
    setIconColor('url(#paint0_linear_0_254)'); // Восстановление градиента при уходе мыши
  };

  const handleClick = () => {
    setIconColor('#064E3B'); // Установка тёмно-зелёного цвета при клике
    setTimeout(() => {
      window.open('https://x.com/', '_blank', 'noopener,noreferrer'); // Открытие новой вкладки после задержки
    }, 500); // Задержка в 200 миллисекунд
  };

  return (
    <div
      className="ml-3 group cursor-pointer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transition-colors duration-200"
      >
        <path
          d="M3.34 4.73775C4.0451 5.52592 4.8292 6.23965 5.68 6.86775C6.47421 7.39406 7.32651 7.82692 8.22 8.15775C8.93678 8.42019 9.67673 8.61438 10.43 8.73775L11.43 8.81775C11.1881 7.72992 11.4051 6.59049 12.03 5.66775C12.6818 4.78163 13.6545 4.18579 14.74 4.00775C15.5549 3.96099 16.3681 4.12637 17.1 4.48775C18.02 5.02775 18.1 5.22775 18.1 5.22775C18.6447 5.12942 19.1753 4.96487 19.68 4.73775L20.54 4.27775C20.3888 4.79641 20.1182 5.27245 19.75 5.66775C19.26 6.11775 18.81 6.44775 18.81 6.44775C19.2547 6.44196 19.6949 6.35731 20.11 6.19775L21.11 5.83775C20.7832 6.31215 20.4078 6.75119 19.99 7.14775C19.51 7.52775 19.12 7.87775 19.12 7.87775C19.2406 9.92007 18.772 11.954 17.77 13.7378C17.0179 15.1884 15.9355 16.4421 14.61 17.3978C13.3205 18.3383 11.8381 18.9804 10.27 19.2778C9.04955 19.5007 7.80309 19.5445 6.57 19.4078C5.5804 19.2572 4.61094 18.9956 3.68 18.6278C3.07093 18.4348 2.50178 18.1333 2 17.7378C3.14684 17.8956 4.31472 17.7826 5.41 17.4078C6.25342 17.0774 7.05281 16.6441 7.79 16.1178C7.2317 16.1128 6.68157 15.983 6.18 15.7378C5.55966 15.4447 5.03076 14.9884 4.65 14.4178C4.48798 14.1737 4.34745 13.9161 4.23 13.6478L4.16 13.3978C4.43127 13.4645 4.71137 13.4881 4.99 13.4678L5.91 13.3278C5.11136 13.1788 4.38394 12.7712 3.84 12.1678C3.25115 11.5315 2.89819 10.7127 2.84 9.84775V9.43775C3.14966 9.62399 3.48733 9.75906 3.84 9.83775C4.08057 9.90563 4.33017 9.93599 4.58 9.92775C3.81336 9.43637 3.24629 8.68855 2.98 7.81775C2.68097 6.78444 2.81073 5.67425 3.34 4.73775Z"
          fill={iconColor} // Использование состояния для цвета
        />
        <defs>
          <linearGradient
            id="paint0_linear_0_254"
            x1="2"
            y1="11.6766"
            x2="21.11"
            y2="11.6766"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#27FF7D" />
            <stop offset="1" stopColor="#18994B" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default TwitterIcon;
